import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'es_MX',
  {
    fdidYouMean: true,
    ffacetNavigation: true,
    fdomainSuggestions: true,
    fvideo: true,
    fCommerceCarrossel: true,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '1b2dde2c-843c-4531-820a-2db03c6519bc',
  ''
);
